import { Mixpanel } from 'services/Tracking/Mixpanel'

// Subscription / My Plan analytics — mirrors Android's MerchantSubscriptionAnalytics
// (subscription_screen_viewed → subscription_plan_selected → subscription_plan_added /
// add_subscription_plan_failed) so web and Android report the same funnel.
const SUBSCRIPTION_SCREEN_VIEWED = 'subscription_screen_viewed'
const SUBSCRIPTION_PLAN_SELECTED = 'subscription_plan_selected'
const SUBSCRIPTION_PLAN_ADDED = 'subscription_plan_added'
const ADD_SUBSCRIPTION_PLAN_FAILED = 'add_subscription_plan_failed'
const PREMIUM_BANNER_SHOWN = 'premium_banner_shown'
// KMP OkSubscriptionAnalytics: the bottom CTA and the SMS/WhatsApp variant picker
const SUBSCRIPTION_CTA_CLICKED = 'subscription_cta_clicked'
const PREMIUM_PLAN_SHEET_SHOWN = 'premium_plan_sheet_shown'
const PREMIUM_PLAN_SHEET_PROCEED_CLICKED = 'premium_plan_sheet_proceed_clicked'

// `source` values shared with mobile: where My Plan was opened from
export const SUBSCRIPTION_SOURCE_MY_PLAN = 'my_plan'
export const SUBSCRIPTION_SOURCE_TXN_ALERT_SETTINGS = 'transactional_alert_settings'

// Premium / expiry banner impression — matches Android's premium_banner_shown
// (props: Source, plan_name).
export const trackPremiumBannerShown = (source: string, plan: string): void => {
  Mixpanel.trackWithPreset(PREMIUM_BANNER_SHOWN, { Source: source, plan_name: plan })
}

export const trackSubscriptionScreenViewed = (source: string): void => {
  Mixpanel.trackWithPreset(SUBSCRIPTION_SCREEN_VIEWED, { source })
}

export const trackSubscriptionPlanSelected = (
  planId: string,
  planName: string,
  source: string
): void => {
  Mixpanel.trackWithPreset(SUBSCRIPTION_PLAN_SELECTED, {
    selected_plan_id: planId,
    selected_plan_name: planName,
    source
  })
}

export const trackSubscriptionPlanAdded = (
  planId: string,
  planName: string,
  source: string
): void => {
  Mixpanel.trackWithPreset(SUBSCRIPTION_PLAN_ADDED, {
    selected_plan_id: planId,
    selected_plan_name: planName,
    source
  })
  // User property (matches Android setCurrentSubscriptionUserProperty).
  if (planName) {
    Mixpanel.people.set({ subscription_plan: planName, current_sms_subscription_plan: planName })
  }
}

export const trackAddSubscriptionFailed = (error: string, source: string): void => {
  Mixpanel.trackWithPreset(ADD_SUBSCRIPTION_PLAN_FAILED, { error, source })
}

// Bottom CTA tapped (Continue / Extend / Upgrade / Downgrade), before any confirmation.
export const trackSubscriptionCtaClicked = (source: string, planId: string): void => {
  Mixpanel.trackWithPreset(SUBSCRIPTION_CTA_CLICKED, { source, selected_plan_id: planId })
}

// "Transaction alert from OkCredit" SMS/WhatsApp picker opened.
export const trackPremiumPlanSheetShown = (source: string): void => {
  Mixpanel.trackWithPreset(PREMIUM_PLAN_SHEET_SHOWN, { source })
}

// Proceed tapped on that picker with a variant chosen.
export const trackPremiumPlanSheetProceedClicked = (source: string, planId: string): void => {
  Mixpanel.trackWithPreset(PREMIUM_PLAN_SHEET_PROCEED_CLICKED, { source, selected_plan_id: planId })
}
